/* eslint-disable react/jsx-no-undef */
import { PicklistValue } from '@rainbow-modules/listview/lib/components/AuditLogs/types';
import { isDefined } from '@rainbow-modules/validation';
import { FormContainer, StyledUniversalForm } from './styled';
import Fields from './fields';

interface FormProps {
    id?: string,
    initialValues?: Record<string, unknown>,
    disabledFields?: string[],
    onSubmit?: (values: Record<string, unknown>) => void,
}

interface FormValues extends Record<string, unknown> {
    name: string;
    description?: string;
    platform?: PicklistValue | string;
}

const mapFormValues = async (currentValues: FormValues) => {
    const {
        name,
        description,
        platform,
    } = currentValues;

    const result: Record<string, unknown> = {
        name,
        description,
        platform,
    };

    return Object.keys(result).reduce((acc: Record<string, unknown>, key) => {
        if (isDefined(result[key]) || result[key] === null) {
            acc[key] = result[key];
        }
        return acc;
    }, {});
};

const Form = ({
    id,
    initialValues,
    disabledFields = [],
    onSubmit,
}: FormProps) => {
    const onSubmitMiddleware = async (formValues: Record<string, unknown>) => {
        if (onSubmit) onSubmit(await mapFormValues(formValues as FormValues));
    };

    return (
        <FormContainer>
            <StyledUniversalForm
                id={id}
                onSubmit={onSubmitMiddleware}
                initialValues={initialValues}
            >
                <Fields disabledFields={disabledFields} />
            </StyledUniversalForm>
        </FormContainer>
    );
};

export default Form;
